import { useMemo } from "react";
import { Link } from "react-router-dom";
import useSeo from "../../hooks/useSeo";
import { useTranslation } from "../../i18n/LanguageProvider";
import { buildNotFoundSeo } from "../../utils/seo";
import "../Directory/Directory.sass";

function NotFound() {
    const { language, t, localizedPath } = useTranslation();
    const seo = useMemo(() => buildNotFoundSeo(language), [language]);

    useSeo(seo);

    return (
        <main className="not-found general-wrapper">
            <div className="not-found__box card-common">
                <h1 className="not-found__title">{t("notFound.title")}</h1>
                <p className="not-found__text">{t("notFound.text")}</p>
                <p className="not-found__links">
                    <Link to={localizedPath("/")}>{t("notFound.back")}</Link>
                    <Link to={localizedPath("/femei")}>{t("notFound.directory")}</Link>
                </p>
            </div>
        </main>
    );
}

export default NotFound;
